import { useState, useEffect } from "react";

const PaymentStatus = () => {
  const [isPaid, setIsPaid] = useState(false);

  useEffect(() => {
    const handlePaymentSuccess = (event) => {
      console.log("Payment Successful!", event.detail);
      setIsPaid(true); // Update UI instantly

      // Send payment ID to backend for verification (optional)
      fetch("/api/verify-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payment_id: event.detail.razorpay_payment_id }),
      }).then((res) => res.json());
    };

    document.addEventListener("payment.captured", handlePaymentSuccess);

    return () => {
      document.removeEventListener("payment.captured", handlePaymentSuccess);
    };
  }, []);

  return <div>{isPaid ? "✅ Payment Successful!" : "⏳ Awaiting Payment..."}</div>;
};

export default PaymentStatus;
